import { render } from "./queryDataPolicy.vue?vue&type=template&id=c95c228e"
import script from "./queryDataPolicy.vue?vue&type=script&lang=js"
export * from "./queryDataPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__